




























import Vue from 'vue';
import globals from '@/globals';
import CardStackHeader from '@/components/card/CardStackHeader.vue';
import CardBlade from '@/components/card/CardBlade.vue';
import CardStackFooter from '@/components/card/CardStackFooter.vue';
import { Component } from 'vue-property-decorator';
import { DECKLIST, MODAL } from '@/store/actions';
import { Decklist } from '@/types/decklist';
import { CardBundle } from '@/types/bundle';

@Component({
  components: {
    CardStackHeader,
    CardBlade,
    CardStackFooter,
  },
})
export default class CardStack extends Vue {
  get decklist(): Decklist {
    return this.$store.state.decklist.decklist;
  }
  get decklistText(): string {
    return this.decklist.toString();
  }

  private copyToClipboard() {
    this.decklist.sort();
    const textArea = document.createElement('textarea');
    textArea.value = this.decklistText;
    document.body.appendChild(textArea);
    // textArea.focus();
    textArea.select();
    document.execCommand('copy');
    // window.getSelection().removeAllRanges();
    document.body.removeChild(textArea);
  }

  private saveToFile() {
    this.decklist.sort();
    const pom = document.createElement('a');
    pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.decklistText));
    pom.setAttribute('download', this.decklist.title || 'New Deck');

    pom.style.display = 'none';
    document.body.appendChild(pom);

    pom.click();

    document.body.removeChild(pom);
  }

  private importFromText() {
    this.$store.commit(MODAL.SET_CLOSE_INFO_NORMAL);
    this.$router.push({ path: this.$route.name || undefined, query: { action: 'import' }});
  }

  private trash() {
    this.$store.commit(DECKLIST.EMPTY);
  }

  private saveToDisk() {
    this.decklist.sort();
    this.$store.commit(DECKLIST.SAVE);
  }

  private importFromDisk() {
    this.$store.commit(MODAL.SET_CLOSE_INFO_NORMAL);
    this.$router.push({ path: this.$route.name || undefined, query: { action: 'load' }});
  }
}
